import { useMemo } from 'react';

import JobCard from '@/components/job-card';
import Link, { LinkVariant } from '@/components/link';
import Typography from '@/components/typography';

import NOMAD_API_CONSTANTS from '@/constants/nomad-api';
import Carousel, { CarouselItem, CarouselVariant } from '@/features/carousel';
import { JobBlocksCardCarouselProps } from '@/features/job-blocks/types';
import { routes } from '@/utils/route-utils';

export default function JobBlocksCardCarousel({
  title,
  subtitle,
  jobs,
  discipline,
  specialty,
}: JobBlocksCardCarouselProps) {
  const searchAllRedirectPath = routes.jobSearch({
    ...NOMAD_API_CONSTANTS.DEFAULT_JOB_SEARCH_QUERY,
    discipline,
    specialty,
  });

  const cards: CarouselItem[] = useMemo(
    () =>
      jobs.map((job) => ({
        id: job.id,
        component: <JobCard {...job} />,
      })),
    [jobs]
  );

  return (
    <div className='relative'>
      <div className='flex flex-col gap-2 bg-primary-light px-8 py-4'>
        <Typography.TextLarge weight='bold' className='md:mr-16'>
          {title}
        </Typography.TextLarge>
        <Typography.Text>{subtitle}</Typography.Text>

        <Carousel variant={CarouselVariant.SCROLLABLE} items={cards} />

        <div className='flex flex-row justify-center'>
          <Link
            variant={LinkVariant.LINK}
            href={searchAllRedirectPath}
            className='my-4 px-10 font-bold text-primary-extra-dark md:absolute md:-top-1 md:right-2 md:px-4 md:py-2'
          >
            See all
          </Link>
        </div>
      </div>
    </div>
  );
}
